import { render, staticRenderFns } from "./openVipStepz.vue?vue&type=template&id=4274e842&scoped=true&"
import script from "./openVipStepz.vue?vue&type=script&lang=js&"
export * from "./openVipStepz.vue?vue&type=script&lang=js&"
import style0 from "./openVipStepz.vue?vue&type=style&index=0&id=4274e842&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4274e842",
  null
  
)

export default component.exports